import log from '@atlassian/jira-common-util-logging/src/log.tsx';

type ResourceErrorFields = {
	name: string;
	message: string;
	component: string;
	skipSentry?: boolean;
};

class ResourceErrorClass extends Error {
	skipSentry: boolean;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	constructor(message: string, options: any) {
		super(message);
		this.name = options.name || 'ResourceError';
		this.skipSentry = options.skipSentry;
	}
}

export const createResourceError = (
	{ name = 'ResourceError', message = '', component = '', skipSentry = false }: ResourceErrorFields,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	errorOverride?: any,
) => {
	log.safeErrorWithoutCustomerData(component, message, errorOverride);

	if (errorOverride) {
		return errorOverride;
	}

	return new ResourceErrorClass(message, { name, skipSentry });
};
